import * as React from "react";
import { Box, Container, useMediaQuery } from "@mui/material";
import { EconomicImpactIntroduction } from "../Statistics/EconomicImpatcIntroduction/EconomicImpactIntroduction";
import { SelectButtons } from "../Statistics/SelectButtons/SelectButtons";
import theme from "../../../components/styles/theme/theme";

export const StickyContent: React.FC = () => {
  const isLgScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme) => theme.palette.common.white,
      }}
      className="hidden-print"
    >
      <Container maxWidth={"xl"}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: `${isLgScreen ? "column" : "row"}`,
            gap: `${isLgScreen ? "20px" : "0"}`,
            padding: "0 25px",
          }}
        >
          <EconomicImpactIntroduction />
          <SelectButtons />
        </Box>
      </Container>
    </Box>
  );
};
